export type AdminBillingTabId =
  | 'providerConfiguration'
  | 'plansPrices'
  | 'planCapabilities'
  | 'promotions'
  | 'analytics';

export interface AdminBillingTab {
  id: AdminBillingTabId;
  label: string;
}

export const ADMIN_BILLING_TABS: AdminBillingTab[] = [
  { id: 'providerConfiguration', label: 'Provider Configuration' },
  { id: 'plansPrices', label: 'Plans & Prices' },
  { id: 'planCapabilities', label: 'Plan Capabilities' },
  { id: 'promotions', label: 'Promotions' },
  { id: 'analytics', label: 'Analytics' },
];

